'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import { observer, inject } from 'mobx-react';

import ReactDOM from 'react-dom';
import {CityList as CityListComp} from '@qnpm/f_citylist';

@inject(stores => {
    const {searchDataStore} = stores,
        {getDepCity, setCityComp, locationHandler} = searchDataStore;

    return {
        setCityComp,
        getDepCity,
        locationHandler
    };
})

@observer
class CityList extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const dom = ReactDOM.findDOMNode(this);
        this.initCityList(dom)
    }

    cityListDepCB = (cityList) => {
        this.props.getDepCity(cityList)
    };

    initCityList = (dom) => {
        this.depCityList = new CityListComp(dom, {
            listType: 'dep',
            hysdk: hysdk,
            godEye: GodEye,
            locationHandler: this.props.locationHandler,
            page_source: 'flight_tejia_rn_dep',
            successCallback: this.cityListDepCB
        });

        this.depCityList.init();

        this.props.setCityComp('depCityListComp', this.depCityList);
    };

    render() {
        return (
            <View style={{zIndex: 200}}/>
        )
    }
}

export default CityList;
